function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77.56,48.24c-.11-3.15-.77-6.17-1.87-8.96l3.59-6.25c.57-.99.48-2.23-.24-3.13l-3.05-3.83c-.71-.9-1.9-1.26-3-.93l-6.76,2.07c-2.56-1.82-5.45-3.21-8.56-4.06l-2.63-6.65c-.42-1.07-1.45-1.77-2.59-1.77h-4.9c-1.15,0-2.17.7-2.59,1.77l-2.77,7.02c-2.77.9-5.34,2.23-7.64,3.93l-7.53-2.31c-1.1-.34-2.28.03-3,.93l-3.05,3.83c-.71.9-.81,2.14-.24,3.13l4.26,7.42c-.76,2.22-1.24,4.57-1.4,7l-7.29,4.99c-.94.65-1.4,1.81-1.14,2.92l1.09,4.78c.25,1.12,1.17,1.96,2.3,2.14l9.18,1.4c1.12,1.77,2.44,3.39,3.92,4.85l-.68,9.32c-.08,1.14.54,2.22,1.57,2.72l4.41,2.13c1.03.5,2.26.31,3.1-.46l6.75-6.23c1.23.17,2.49.27,3.77.27.94,0,1.88-.05,2.8-.14l6.61,6.11c.84.78,2.07.96,3.1.46l4.41-2.13c1.03-.5,1.66-1.57,1.57-2.72l-.61-8.36c1.97-1.74,3.68-3.76,5.08-6l7.95-1.22c1.13-.17,2.04-1.02,2.3-2.14l1.09-4.78c.25-1.12-.2-2.28-1.14-2.92l-6.15-4.21ZM50,69.21c-11.09,0-20.08-8.99-20.08-20.08s8.99-20.08,20.08-20.08,20.08,8.99,20.08,20.08-8.99,20.08-20.08,20.08Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeSettings);
export default __webpack_public_path__ + "static/media/acae_settings.060af292.svg";
export { ForwardRef as ReactComponent };